module.exports = __webpack_public_path__ + "static/media/Achievement75.cd56597a.jpg";